import service from '@/utils/server';
const modName='/rcpv/sch/';
const timeRangeModName='/common/web/plantStatisticalTimeRange/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'schPageInfo',
    method: 'post',
    data
  });
};

//初始化更新对象
export const initUpdate = data => {
  return service({
    url: modName + 'editDetails',
    method: 'post',
    data
  });
};

//导出excel
export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'schExport',
    method: 'post',
    data
  });
};

//导入方法
export const planVehicleUpLoad = data => {
  let config = {
    responseType: "blob",
    timeout: 500000, // 请求超时时间
    headers: {
      "Content-Type": "multipart/form-data"
    }
  };
  return service({
    ...config,
    url: modName + 'rcpvImport',
    method: 'post',
    data
  });
};

//模板下载
export const template = data => {
  let config = {
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'template/' + data.templateName,
    method: 'post',
    data
  });
};

//取消
export const cancleSubmit = data => {
  return service({
    url: modName + 'cancel',
    method: 'post',
    data
  });
};

//玉米倒运顺序调整提交
export const adjustSchSeqSubmit = data => {
  return service({
    url: modName + 'adjustSchSeqSubmit',
    method: 'post',
    data
  });
};

//玉米倒运库位调整
export const initDestStorageUpdate = data => {
  return service({
    url: modName + 'schDetails',
    method: 'post',
    data
  });
};

//玉米倒运库位调整提交
export const destStorageEditSubmit = data => {
  return service({
    url: modName + 'updateDestStorageSubmit',
    method: 'post',
    data
  });
};

//查询基地一天的时间范围
export const getPlantTimeRangeOfOneDay = data => {
  return service({
    url: timeRangeModName+'selectPlantTimeRangeOfOneDay/'+data.plantCode,
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/bd/corn/reshipCornPlanVehicle/api/index.js